module.exports = __webpack_public_path__ + "img/Cara_Amarilla.5027e0a4.svg";